// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__1B-Mt","additionalInfo":"AgreementModal_additionalInfo__94sr4"};